import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useArInvoiceEmail() {
  const queryClient = useQueryClient();

  const sendMutation = useMutation(
    orpc.accountsReceivable.arInvoiceEmail.send.mutationOptions({
      onSuccess: (_data, variables) => {
        void queryClient.invalidateQueries({
          queryKey: orpc.accountsReceivable.arInvoices.get.key({
            input: { id: variables.invoiceId },
          }),
        });
      },
    }),
  );

  const previewMutation = useMutation(
    orpc.accountsReceivable.arInvoiceEmail.preview.mutationOptions(),
  );

  return {
    send: sendMutation.mutateAsync,
    isSending: sendMutation.isPending,
    preview: previewMutation.mutateAsync,
    isPreviewing: previewMutation.isPending,
    previewData: previewMutation.data ?? null,
    resetPreview: previewMutation.reset,
  };
}
